<template>
 <div class="d-flex flex-column justify-content-center align-items-center">
    <div class="reproductionTitle">Cargar Datos Reproductivos</div>


    <div class="sexSelect">
       <b-link :to="{name:'advance-healthreproductionmale'}"> <b-img src="@/assets/images/ganImage/maleBrown.png"></b-img></b-link>
       <b-link :to="{name:'advance-healthreproductionfemale'}"> <b-img src="@/assets/images/ganImage/femaleBrown.png"></b-img></b-link>
    </div>
    <ControlMenu />
 </div>
</template>

<script>
import ControlMenu from '@/components/ControlMenu.vue'
import {BImg, BLink} from 'bootstrap-vue';
export default {
    components:{
        ControlMenu,
        BImg,
        BLink,
    },
    data() {
        return {

        }
    },
}
</script>

<style lang="scss">
.reproductionTitle{
    position: absolute;
    height: 29px;
    top: calc(50% - 29px/2 - 249.5px);
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;
    }


.sexSelect {
    position: absolute;
    top:30%;
}
</style>